import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { CookieEnum } from '../../enums/cookie-enum';
import { useCheckMyCompanySubscriptionExistQuery } from '../../store/apiSlice/subscription/subscriptionApi';
import { selectAuthData } from '../../store/selectors/authSelector';
import { Loading } from '../shared/loader/Loader';

const ProtectedRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const authData = useSelector(selectAuthData);
  const isCompany = authData?.user?.role === 'COMPANY';

  const { data: isSubscriptionData, isLoading } =
    useCheckMyCompanySubscriptionExistQuery(null, {
      skip: !isCompany,
    });

  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const token = Cookies.get(CookieEnum.ACCESS_TOKEN);
    const role = authData?.user?.role;
    const isOnSubscriptionFlow =
      location.pathname === '/subscription-plans' ||
      location.pathname === '/subscription-payment' ||
      location.pathname === '/subscription-successfully-paid' ||
      location.pathname === '/company-questionnaire';

    if (!token && location.pathname !== '/login') {
      navigate('/login');
      setIsChecking(false);
      return;
    }

    if (!isLoading) {
      if (
        role === 'COMPANY' &&
        !isOnSubscriptionFlow &&
        !isSubscriptionData?.data
      ) {
        navigate('/subscription-plans', { replace: true });
        setIsChecking(false);
        return;
      }
      setIsChecking(false);
    }
  }, [
    authData?.user?.role,
    isLoading,
    isSubscriptionData,
    location.pathname,
    navigate,
  ]);

  if (isChecking || isLoading) {
    return <Loading />;
  }

  if (!Cookies.get(CookieEnum.ACCESS_TOKEN)) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
